'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SelectField = require('material-ui/SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _MenuItem = require('material-ui/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.onBlur = _this.onBlur.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'getItem',
    value: function getItem(item) {
      if (item.label && item.label.length > 25) {
        item.label = item.label.substring(0, 22) + '...';
      } else if (item.primaryText && item.primaryText.length > 25) {
        item.label = item.primaryText.substring(0, 22) + '...';
      }
      return _react2.default.createElement(_MenuItem2.default, _extends({ key: item.value }, item));
    }
  }, {
    key: 'onBlur',
    value: function onBlur(event, index, value) {
      this.props.onBlur(value);
    }
  }, {
    key: 'onChange',
    value: function onChange(event, index, value) {
      this.props.onChange(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          items = _props.items,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          others = _objectWithoutProperties(_props, ['items', 'onBlur', 'onChange']);

      return _react2.default.createElement(
        _SelectField2.default,
        _extends({}, others, {
          onBlur: this.onBlur,
          onChange: this.onChange
        }),
        items.map(this.getItem)
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  items: _react2.default.PropTypes.array.isRequired,
  onBlur: _react2.default.PropTypes.func.isRequired,
  onChange: _react2.default.PropTypes.func.isRequired,
  value: _react2.default.PropTypes.any
};
_class.defaultProps = {
  items: [],
  onBlur: function onBlur(value) {
    return value;
  },
  onChange: function onChange(value) {
    return value;
  },
  value: null
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/Select/Select.js
 ** module id = 499
 ** module chunks = 0
 **/